import React, { Component } from 'react'
import Button from './Button'
import Headline from './Headline'
import LoadingText from './LoadingText'
import Sandwich from './Sandwich'
import SandwichName from './SandwichName'
import Close from './Close'

// Ingredients data
import * as BUTTONS from '../data/buttons.json'
import * as HEADLINES from '../data/headlines.json'
import * as INGREDIENTS from '../data/ingredients.json'

class Generator extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      bread: this.selectRandom(INGREDIENTS.breads, 1),
      buttonText: 'Give it to me!',
      clickHandler: props.clickHandler,
      garnishes: this.selectRandom(INGREDIENTS.garnishes, 3).sort(this.sortByCoverage),
      generated: false,
      headline: {
        image: 'go-nuts',
        text: 'Go Nuts'
      },
      loading: false,
      peanutButter: this.selectRandom(INGREDIENTS.peanutButters, 1),
    };

    this.generateNew = this.generateNew.bind(this);
  }

  sortByCoverage(a, b) {
    if (a.coverage < b.coverage) {
      return 1;
    }
    else if (a.coverage > b.coverage) {
      return -1;
    }
    else {
      return 0;
    }
  }

  // Randomly select count things from arr (without replacement)
  selectRandom(arr, count) {
    var results = [];
    var clone = arr.slice();

    for (var i = 0; i < count; i++) {
      // Randomly choose 1 element from clone using splice
      var choice = clone.splice(Math.floor(Math.random() * clone.length), 1)[0];
      results.push(choice);
    }

    if (results.length === 1) {
      results = results[0];
    }

    return results;
  }

  // Generate a new sandwich!
  generateNew() {
    this.setState({
      loading: true,
    });

    setTimeout(() => {
      this.setState({
        bread: this.selectRandom(INGREDIENTS.breads, 1),
        buttonText: this.selectRandom(BUTTONS, 1),
        garnishes: this.selectRandom(INGREDIENTS.garnishes, 3).sort(this.sortByCoverage),
        generated: true,
        headline: this.selectRandom(HEADLINES, 1),
        loading: false,
        peanutButter: this.selectRandom(INGREDIENTS.peanutButters, 1),
      });
    }, 2000);
  }

  render() {
    var inner;

    if (this.state.loading) {
      inner = <LoadingText />;
    }
    else {
      inner = (
        <div>
          <Headline src={this.state.headline.image} alt={this.state.headline.text} generated={this.state.generated} />
          
          <Sandwich bread={this.state.bread}
                    garnishes={this.state.garnishes}
                    peanutButter={this.state.peanutButter}
                    generated={this.state.generated} />

          {this.state.generated ? (
            <div class="generator__wrap">
              <div className="generator__text generator__text--large">
                <SandwichName bread={this.state.bread.name}
                              garnishes={this.state.garnishes.map((g) => g.name )}
                              peanutButter={this.state.peanutButter.name} />
              </div>
              
              <div className="generator__text">Happy National Peanut Butter Sandwich Day!</div>
            </div>
          ) : (
            <div className="generator__wrap">
              <div className="generator__text generator__text--large">From classic to crunchy to downright kooky, discover the peanut butter sandwich of your dreams.</div>
            </div>
          )}

          <Button clickHandler={this.generateNew} text={this.state.buttonText} />
        </div>
      );
    }
    
    return (
      <div className="generator">
        <div className="container">
          <div className="close">
            <div className="row">
              <div className="col-12">
                <Close clickHandler={this.state.clickHandler} />
              </div>
            </div>
          </div>
            <div className="row justify-content-center">
              <div className="col-12 col-md-10 col-lg-8">
                {inner}
              </div>
            </div>
          </div>
        
      </div>
    );
  }
}

export default Generator



// WEBPACK FOOTER //
// ./src/scripts/components/Generator.js